module.exports = __webpack_public_path__ + "img/torus.63907dba.png";